import { render, staticRenderFns } from "./RegionChart.vue?vue&type=template&id=76d7d5e0&scoped=true"
import script from "./RegionChart.vue?vue&type=script&lang=js"
export * from "./RegionChart.vue?vue&type=script&lang=js"
import style0 from "./RegionChart.vue?vue&type=style&index=0&id=76d7d5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d7d5e0",
  null
  
)

export default component.exports